import React from "react";
import heroImage from "../../assets/images/Hero_Back.jpg"; // Update with your actual image path

const About = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="bg-pink-100 py-20">
        <div className="container mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          {/* Text */}
          <div>
            <h1
              className="text-5xl font-bold text-pink-600 mt-6 mb-6"
              style={{ fontFamily: "Barlow Semi Condensed" }}
            >
              About Us – Pink Help
            </h1>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              Pink Help is the official platform of Women of the World, Inc. — the world’s first
              global women-focused ecosystem connecting women in 250+ countries to trusted,
              verified support across all areas of life.
            </p>
            <p className="text-md text-gray-700 leading-relaxed">
              We exist to ensure no woman stands alone when seeking health, legal, business,
              family, or community support. Our platform is a living movement for equality,
              dignity, and access.
            </p>
          </div>

          {/* Image */}
          <div className="mt-16">
            <img
              src={heroImage}
              alt="Empowering women across the world"
              className="rounded-3xl shadow-lg"
            />
          </div>
        </div>
      </div>

      {/* About Content Sections */}
      <div className="bg-white py-20">
        <div className="container mx-auto px-6 space-y-16">
          {/* Who We Are */}
          <div>
            <h2 className="text-3xl font-bold text-pink-600 mb-4">Who We Are</h2>
            <p className="text-gray-700 text-lg leading-relaxed max-w-4xl">
              Pink Help is the World’s First Women-Focused Global Platform, connecting women in every
              country to trusted, verified services — from health and legal aid to business, education, and
              housing. We are the official platform of <strong>Women of the World, Inc.</strong>, a global organization
              committed to empowering women by creating access, visibility, and opportunity through digital
              infrastructure.
            </p>
          </div>

          {/* What We Do */}
          <div>
            <h2 className="text-3xl font-bold text-pink-600 mb-4">What We Do</h2>
            <p className="text-gray-700 text-lg leading-relaxed max-w-4xl mb-4">
              We operate over 250 country-specific portals, called <strong>Pink Pages</strong>, where women can easily
              browse services in 10 core categories:
            </p>
            <ul className="grid grid-cols-2 md:grid-cols-3 gap-4 text-gray-800 font-medium list-disc list-inside">
              <li>Health</li>
              <li>Legal</li>
              <li>Education</li>
              <li>Jobs</li>
              <li>Business</li>
              <li>Finance</li>
              <li>Housing</li>
              <li>Family</li>
              <li>Fashion</li>
              <li>Community</li>
            </ul>
          </div>

          {/* Why We Exist */}
          <div>
            <h2 className="text-3xl font-bold text-pink-600 mb-4">Why We Exist</h2>
            <p className="text-gray-700 text-lg leading-relaxed max-w-4xl">
              Because no woman should feel alone when she needs help. Pink Help was created to become a
              global gateway — where women can find support within seconds, and where service providers can
              reach the right audience with purpose and dignity.
            </p>
          </div>

          {/* Vision */}
          <div>
            <h2 className="text-3xl font-bold text-pink-600 mb-4">Our Vision</h2>
            <p className="text-gray-700 text-lg leading-relaxed max-w-4xl">
              A world where every woman can access trusted help, anytime, anywhere.
            </p>
          </div>

          {/* Structure */}
          <div>
            <h2 className="text-3xl font-bold text-pink-600 mb-4">Our Structure</h2>
            <ul className="list-disc list-inside text-gray-800 text-lg space-y-2 max-w-4xl">
              <li><strong>Parent Company:</strong> Women of the World, Inc.</li>
              <li><strong>Platform:</strong> Pink Help (operates all country portals)</li>
              <li><strong>Partners:</strong> Verified local advertisers, NGOs, professionals, and premium sponsors</li>
              <li><strong>Supporters:</strong> Country representatives, category leaders, and global allies</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
